import {useState} from "react";

import {ModalProps} from "@components/modals";

export type InfoModalProps = Partial<ModalProps> & {
  isOpen: boolean;
  confirmationContent?: string | React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
};

type UseInfoModalReturn = {
  openInfoModal: (info: Omit<InfoModalProps, "isOpen">) => void;
  closeInfoModal: () => void;
  infoModalProps: InfoModalProps;
};

export default function useInfoModal(): UseInfoModalReturn {
  const [infoModal, setInfoModal] = useState<InfoModalProps>({
    isOpen: false,
  });

  const openInfoModal = (info: Omit<InfoModalProps, "isOpen">) => {
    if (!infoModal.isOpen) {
      setInfoModal({
        ...info,
        isOpen: true,
      });
    }
  };

  const closeInfoModal = () => {
    setInfoModal({
      ...infoModal,
      isOpen: false,
    });
  };

  return {
    openInfoModal,
    closeInfoModal,
    infoModalProps: infoModal,
  };
}
